<script setup>
//region Imports
import mapboxgl from 'mapbox-gl'
import { ref, watch, onMounted, reactive, computed } from 'vue'
import StepHeader from '../components/StepHeader.vue'
import helpers from "../helpers/index.js";
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const readSelectedItems = () => JSON.parse(localStorage.getItem('tc-claim-selected-items'))

const clickToBack = () => {
  location.replace('#/order')
}

const clickToContinue = () => {
  location.replace('#/claim/' + (data?.isEligible ? 'start' : 'ineligible'))
}

const estimatedDeliveryDate = computed(() => {
  const date = data?.shipmentInformation?.shopify_estimated_delivery_at
  if (!date) return null
  return (new Date(date)).toLocaleDateString()
})

const loadMap = () => {
  if (!latitude.value || !longitude.value) return

  mapboxgl.accessToken = 'pk.eyJ1IjoidW5hZ2lleWFsIiwiYSI6ImNsdHNxZmxhcTBydXIybHFxdTVoZms3dGcifQ.vpcQ0qsoK54CaLUO_h-Ayg'

  map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/light-v11',
    center: [longitude.value, latitude.value],
    zoom: 14,
    attributionControl: false
  })
  // map.addControl(new mapboxgl.NavigationControl())

  const geoJson = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [longitude.value, latitude.value],
        },
        properties: {
          title: 'Tres Colori',
          description: 'Your package was delivered here.',
        },
      },
    ],
  }

  for (const feature of geoJson.features) {
    const el = document.createElement('div')
    el.className = 'marker'
    new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(map)
  }
}
//endregion
//region Variables
const data = reactive(readData() ?? {})
const items = reactive(readSelectedItems() ?? [])
let orderNumber = ref(data?.orderNumber)
let latitude = ref(data?.shipmentInformation?.latitude)
let longitude = ref(data?.shipmentInformation?.longitude)
let isMobile = helpers.isMobile()
//endregion
//region Lifecycle
let map = null
onMounted(() => {
  if (!orderNumber.value) {
    location.replace('/')
    return
  }

  loadMap()
})
//endregion
</script>

<template>

<figure v-if="!isMobile"
        class="w-full h-[340px] overflow-hidden bg-no-repeat bg-right bg-cover"
        style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);"
        @resize.window="helpers.isMobile()"
>&nbsp;</figure>


  <div class="px-[20px] my-[30px] lg:px-[40px]">

    <step-header :data="data" :items="items"/>

    <main class="max-w-[420px] mx-auto lg:mb-[40px]">

      <div class="flex flex-row items-center">
        <button type="button" @click="clickToBack">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h1 class="font-bold text-tc-subtitle font-minionpro text-tc-black tracking-wider" v-text="`Where's My Package?`"></h1>
      </div>

      <div class="my-[30px]">
        <div class="flex flex-row justify-between">
          <h3 class="font-medium text-tc-maroon text-tc-xl tracking-wider font-avenir" v-text="data?.shipmentStatus ?? 'N/A'"></h3>
          <p v-if="estimatedDeliveryDate" class="text-tc-maroon text-tc-xl tracking-wider font-avenir" v-text="estimatedDeliveryDate"></p>
        </div>
        <div class="grid grid-cols-4 gap-3 my-5">
          <div class="bg-tc-maroon w-full h-1.5">&nbsp;</div>
          <div class="bg-tc-maroon w-full h-1.5">&nbsp;</div>
          <div class="bg-tc-maroon w-full h-1.5">&nbsp;</div>
          <div class="bg-tc-maroon w-full h-1.5">&nbsp;</div>
        </div>
      </div>

      <p v-if="data?.shipmentStatus === 'delivered'"
         class="text-tc-xl text-black font-avenir font-normal tracking-wider"
      >Your package looks like it has been delivered, you can report an issue below if you believe your items) have
        been stolen.
      </p>

      <div v-if="latitude && longitude" class="h-full w-full min-h-[250px] mx-auto border my-[30px]" id="map"></div>

      <div class="flex flex-row justify-between my-[30px]">
        <button type="button"
                @click="clickToBack"
                class="text-tc-xl font-normal tracking-wider text-black py-2.5 px-8 border-b border-tc-creme font-avenir"
        >Back
        </button>
        <button type="submit"
                @click="clickToContinue"
                class="text-tc-xl font-normal tracking-wider text-black py-2.5 px-6 border border-tc-creme font-avenir"
        >Report a problem
        </button>
      </div>

    </main>

  </div>

</template>

<style scoped>
.marker {
  /*background-image: url('mapbox-icon.png');*/
  background-color: red;
  background-size: cover;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
</style>